import { Injectable, inject, signal } from '@angular/core';

import { API_REPO } from '../../core/services/repositories/api-repo.token';
import { AuthUser, UserLanguage } from '../../core/services/repositories/api-repository';
import { I18nService } from '../../core/i18n/i18n.service';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly repo = inject(API_REPO);
  private readonly i18nService = inject(I18nService);

  readonly currentUser = signal<AuthUser | null>(null);

  login(email: string, password: string): Promise<AuthUser | null> {
    return this.repo.login({ email, password });
  }

  requestSignup(fullName: string, email: string, password: string): Promise<void> {
    return this.repo.requestSignup({ fullName, email, password });
  }

  requestPasswordOtp(email: string): Promise<boolean> {
    return this.repo.requestPasswordOtp(email);
  }

  verifyPasswordOtp(email: string, otp: string): Promise<boolean> {
    return this.repo.verifyPasswordOtp(email, otp);
  }

  resetPassword(email: string, nextPassword: string): Promise<boolean> {
    return this.repo.resetPassword(email, nextPassword);
  }

  updateLanguage(language: UserLanguage): void {
    const user = this.currentUser();

    if (!user) {
      return;
    }

    this.currentUser.set({ ...user, language });
    this.i18nService.useLanguage(language);
  }

  upsertCurrentUser(user: AuthUser): void {
    this.currentUser.set(user);
    this.i18nService.useLanguage(user.language ?? 'en');
  }

  logout(): void {
    this.currentUser.set(null);
  }
}
